import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { Link } from 'react-router-dom';
import signin from "../../assets/img/signin.svg";
import { userRegister, userResendOtp, verifyOtp } from '../../Redux/Auth';
import Footer from '../Layout/Footer';
import Header from '../Layout/Header';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from "react-router-dom";
import firebase from 'firebase/compat/app';
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { firebaseConfig } from '../../fireBaseConfig';
import ToasterMessage from '../ToasterMessage';
import loader from '../../assets/img/loader.gif';
import { setOneSignal } from '../functions';
import { useDispatch, useSelector } from 'react-redux';
import { setUserLoginDetails } from '../../slices/user/userSlice';

const SignUp = () => {
    const dispatch = useDispatch()
    const users = useSelector((state) => state.user)

    const app = firebase.initializeApp(firebaseConfig);
    const auth = getAuth(app);
    const [password, setPassword] = useState(false);
    const [confirmpassword, setConfirmPassword] = useState(false);
    const [otpError, setOtpError] = useState(false);
    const [toaster, setToaster] = useState("");
    const [isloader, setIsloader] = useState(false);

    const viewPassword = () => {
        setPassword(!password);
    }
    const viewConfirmPassword = () => {
        setConfirmPassword(!confirmpassword);
    }

    const navigate = useNavigate();



    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            type_of_user: "1",
            first_name: "",
            last_name: "",
            phone: "",
            email: "",
            username: "",
            password: "",
            confirmpassword: "",
            otp: "",
            gender: "",
            terms_and_conditions: "",

        },
        validationSchema: Yup.object().shape({
            first_name: Yup.string().matches(/^[a-zA-Z\-]+$/, 'Enter a valid name')
                .required('Required'),
            last_name: Yup.string().matches(/^[a-zA-Z\-]+$/, 'Enter a valid name')
                .required('Required'),
            phone: Yup.string().matches(/^[6-9]\d{9}$/, 'Enter a valid mobile number')
                .required('Required'),
            email: Yup.string().matches(/(\<|^)[\w\d._%+-]+@(?:[\w\d-]+\.)+(\w{2,})(\>|$)/, 'Enter a valid email')
                .required('Required'),
            username: Yup.string()
                .required('Required'),
            password: Yup.string()
                .required('Password is mandatory')
                .min(8, 'Password must be at 8 char long'),
            confirmpassword: Yup.string()
                .required('Password is mandatory')
                .min(8, 'Password must be at 8 char long'),
            type_of_user: Yup.string()
                .required('Required'),
            gender: Yup.string()
                .required('Required'),
            terms_and_conditions: Yup.string()
                .required('Required'),

        }),
        onSubmit: (values) => {
            __formSubmit(values)
        },
    });
    const createFireBaseUser = async (email, password) => {
        await createUserWithEmailAndPassword(auth, email, email)
            .then((userCredential) => {
                // Signed in 
                const user = userCredential.user;
                // ...
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                // ..
            });
        setSwitchbutton("Third");
    }

    const __formSubmit = (values) => {

        if (values.password === values.confirmpassword) {
            setIsloader(true)
            var password1 = values.password
            let formData = new FormData();    //formdata object
            let username = values.username.toLowerCase()
            formData.append("first_name", values.first_name);
            formData.append("last_name", values.last_name);
            formData.append("phone", values.phone);
            formData.append("email", values.email.toLowerCase());
            formData.append("username", username);
            formData.append("password", values.password);
            formData.append("type_of_user", values.type_of_user);
            formData.append("gender", values.gender);
            formData.append("terms_and_conditions", values.terms_and_conditions);
            userRegister({ formData })((response) => {
                if (response && response.status) {
                    setIsloader(false)
                    localStorage.setItem('refresh_token', response.data.refresh);
                    localStorage.setItem('token', response.data.token);
                    localStorage.setItem('user_type', response.data.user.type_of_user);
                    localStorage.setItem('user_name', response.data.user.username);
                    localStorage.setItem('user_image', response.data.user.image.image);
                    dispatch(setUserLoginDetails({
                        ...response.data.user,
                        isAuth: false,
                        token: response.data.token,
                        refresh_token: response.data.refresh,
                        user_type: response.data.user.type_of_user,
                        notificationCount: ""

                    }))

                    // setShowOtp(true)

                    createFireBaseUser(response.data.user.email, password1)

                }
                else {

                    formik.setErrors({
                        username: response?.response?.data?.data?.errors?.username,
                        phone: response?.response?.data?.data?.errors?.phone,
                        email: response?.response?.data?.data?.errors?.email,
                    });
                    setSwitchbutton("First");
                    setIsloader(false)
                    // setToaster('error')
                }

            });
        }
        else {
            // alert("Password Mismatch");
            setToaster("Mismatch")
            setTimeout(() => {
                setToaster("")

            }, 2000);
        }
    };

    const [switchbutton, setSwitchbutton] = useState("First");

    const checkRemote = (e) => {

        if (formik.values.type_of_user && formik.values.first_name && formik.values.last_name && formik.values.phone && formik.values.email && formik.values.gender && formik.values.terms_and_conditions && formik.values.type_of_user != "" && formik.values.first_name != "" && formik.values.last_name != "" && formik.values.phone != "" && formik.values.email != "" && formik.values.gender != "" && formik.values.terms_and_conditions != "") {
            setSwitchbutton("Second");
        }
    }

    const __onVerifyOtp = async (e) => {
        e.preventDefault();
        setIsloader(true)
        // localStorage.setItem('token', localStorage.getItem('token_temp'))
        // localStorage.removeItem('token_temp')
        let somePromise = setOneSignal();
        somePromise.then((value) => value);
        const oneSignalPlayerID = await somePromise;
        verifyOtp(formik.values.otp, oneSignalPlayerID)((response) => {
            if (response.status) {
                setIsloader(false)
                localStorage.setItem('user_image', response.data.image.image);
                localStorage.setItem('user_id', response.data.id);
                dispatch(setUserLoginDetails({
                    ...users,
                    isAuth: response.data.type_of_user == 1 ? true : false,
                    user_type: response.data.type_of_user,
                    notificationCount: ""

                }))
                // setShowOtp(false)
                if (response.data.type_of_user && response.data.type_of_user == 1) {
                    navigate("/");
                }
                else {
                    // localStorage.setItem('token_temp', localStorage.getItem('token'))
                    // localStorage.removeItem('token')
                    navigate("/userdetails");
                }
            }
            else {
                setIsloader(false)
                setOtpError(response?.response?.status == 400 ? "Invalid OTP" : "Something Went Wrong")

                // localStorage.setItem('token_temp', localStorage.getItem('token'))
                // localStorage.removeItem('token')
            }

        });

    }

    const checkGender = (e) => {


    }

    const resendOTP = () => {

        userResendOtp(
            formik.values.phone,
            localStorage.getItem("user_type")
        )((response) => {

        });
    };
    return (
        <React.Fragment>
            <ToasterMessage toaster={toaster} setToaster={setToaster} />
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>
                                    Sign Up </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Sign Up</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="signinpage">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 mt-5">
                            <img src={signin} alt="" className="img-fluid" />
                        </div>
                        <div className="col-lg-6">
                            <div className="login-wrap">
                                <div className="login-html">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="signintitle">
                                                <h1>Sign Up</h1>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="login-form">

                                        <Form
                                            onSubmit={formik.handleSubmit}
                                        >
                                            {switchbutton === "First" ?
                                                <React.Fragment>
                                                    <Form.Group className="mb-3" controlId="formBasicSelect">
                                                        <Form.Label>Select User <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                                        <Form.Select
                                                            name="type_of_user"
                                                            className='mb-3'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.type_of_user}
                                                            required
                                                        >
                                                            <option value={1}>Buyer</option>
                                                            <option value={2}>Seller</option>
                                                        </Form.Select>
                                                    </Form.Group>

                                                    <Form.Group className="mb-3" controlId="formBasicText">
                                                        <Form.Label>First Name <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                                        <Form.Control
                                                            name='first_name'
                                                            onChange={formik.handleChange}
                                                            isValid={formik.touched.first_name && !formik.errors.first_name}
                                                            isInvalid={!!formik.errors.first_name && formik.touched.first_name}
                                                            onBlur={formik.handleBlur}
                                                            maxLength="30"
                                                            placeholder='Enter First Name'
                                                            required
                                                            value={formik.values.first_name}
                                                            type="text"
                                                        />
                                                        <Form.Control.Feedback type="invalid">{formik.errors.first_name}</Form.Control.Feedback>
                                                    </Form.Group>

                                                    <Form.Group className="mb-3" controlId="formBasicText">
                                                        <Form.Label>Last Name <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                                        <Form.Control
                                                            name='last_name'
                                                            onChange={formik.handleChange}
                                                            isValid={formik.touched.last_name && !formik.errors.last_name}
                                                            isInvalid={!!formik.errors.last_name && formik.touched.last_name}
                                                            onBlur={formik.handleBlur}
                                                            maxLength="30"
                                                            placeholder='Enter Last Name'
                                                            required
                                                            value={formik.values.last_name}
                                                        />
                                                        <Form.Control.Feedback type="invalid">{formik.errors.last_name}</Form.Control.Feedback>
                                                    </Form.Group>


                                                    <Form.Group className="mb-3" controlId="formBasicNumber">
                                                        <Form.Label>Mobile Number <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                                        <Form.Control
                                                            name='phone'
                                                            onChange={formik.handleChange}
                                                            isValid={formik.touched.phone && !formik.errors.phone}
                                                            isInvalid={!!formik.errors.phone && formik.touched.phone}
                                                            onBlur={formik.handleBlur}
                                                            type="tel"
                                                            maxLength={10}
                                                            placeholder='Enter Mobile Number'
                                                            required
                                                            value={formik.values.phone}
                                                        />
                                                        <Form.Control.Feedback type="invalid">{formik.errors.phone}</Form.Control.Feedback>
                                                    </Form.Group>

                                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                                        <Form.Label>Email <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                                        <Form.Control
                                                            name='email'
                                                            onChange={formik.handleChange}
                                                            isValid={formik.touched.email && !formik.errors.email}
                                                            isInvalid={!!formik.errors.email && formik.touched.email}
                                                            onBlur={formik.onBlur}
                                                            maxLength="30"
                                                            placeholder='Enter Email'
                                                            required
                                                            value={formik.values.email}
                                                            type="email"
                                                        />
                                                        <Form.Control.Feedback type="invalid">{formik.errors.email}</Form.Control.Feedback>
                                                    </Form.Group>

                                                    <Form.Group className="mb-3" controlId="formBasicRadiobutton">
                                                        <Form.Label>Gender <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                                        <div className="mb-3 gender-dflex">
                                                            <Form.Check
                                                                inline
                                                                label="Male"
                                                                value="M"
                                                                checked={formik.values.gender === 'M' ? true : false}
                                                                name="gender"
                                                                type="radio"
                                                                onChange={formik.handleChange}
                                                                // id={`inline-${type}-1`}
                                                                onClick={(e) => { formik.handleChange(e); checkGender(e) }}
                                                                required
                                                            />
                                                            <Form.Check
                                                                inline
                                                                label="Female"
                                                                value="F"
                                                                checked={formik.values.gender === 'F' ? true : false}
                                                                name="gender"
                                                                type="radio"
                                                                onChange={formik.handleChange}
                                                                // id={`inline-${type}-2`}
                                                                onClick={(e) => { formik.handleChange(e); checkGender(e) }}
                                                                required
                                                            />
                                                            <Form.Check
                                                                inline
                                                                label="Others"
                                                                value="O"
                                                                checked={formik.values.gender === 'O' ? true : false}
                                                                name="gender"
                                                                type="radio"
                                                                onChange={formik.handleChange}
                                                                // id={`inline-${type}-2`}
                                                                onClick={(e) => { formik.handleChange(e); checkGender(e) }}
                                                                required
                                                            />
                                                        </div>

                                                    </Form.Group>

                                                    <Form.Group className="mb-3 d-flex " controlId="formBasicCheckbox">
                                                        <Form.Check
                                                            required
                                                            type="checkbox"
                                                            name="terms_and_conditions"
                                                            onChange={formik.handleChange}
                                                            value={formik.values.terms_and_conditions}
                                                            checked={formik.values.terms_and_conditions}
                                                        />
                                                        <Form.Label>By submitting you accept our <Link className='terms-conditons' to='/termsofservices'>Terms and Conditions</Link> </Form.Label>
                                                    </Form.Group>
                                                    <div className="group">
                                                        <Button type="submit" className="btn btn-primary next-btn mt-3 mb-3" onClick={(e) => checkRemote(e)}>Next</Button>
                                                    </div>
                                                    <div className="hr"></div>
                                                    <div className="foot-lnk">
                                                        <p>
                                                            Already have an account? <Link to="/signin">Sign In</Link>
                                                        </p>
                                                    </div>
                                                </React.Fragment>
                                                :
                                                switchbutton === "Second" ?
                                                    <React.Fragment>
                                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                                            <Form.Label>User Name <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                                            <Form.Control
                                                                name='username'
                                                                onChange={formik.handleChange}
                                                                isValid={formik.touched.username && !formik.errors.username}
                                                                isInvalid={!!formik.errors.username && formik.touched.username}
                                                                onBlur={formik.onBlur}
                                                                maxLength="40"
                                                                placeholder='Enter the User Name'
                                                                required
                                                                value={formik.values.username}
                                                            />
                                                            <Form.Control.Feedback type="invalid">{formik.errors.username}</Form.Control.Feedback>
                                                        </Form.Group>

                                                        <Form.Group className="mb-3" controlId="formBasicPassword">
                                                            <Form.Label>Create Password <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                                            <Form.Control
                                                                name='password'
                                                                type={password ? "text" : "password"}
                                                                onChange={formik.handleChange}
                                                                isValid={formik.touched.password && !formik.errors.password}
                                                                isInvalid={!!formik.errors.password && formik.touched.password}
                                                                onBlur={formik.onBlur}
                                                                maxLength="20"
                                                                placeholder='Password'
                                                                required
                                                                value={formik.values.password}
                                                            />
                                                            <div className='icon-eye'>
                                                                {password ?
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" onClick={() => { viewPassword() }} className="bi bi-eye" viewBox="0 0 16 16">
                                                                        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                                                                        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                                                                    </svg>
                                                                    :
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" onClick={() => { viewPassword() }} className="bi bi-eye-slash" viewBox="0 0 16 16">
                                                                        <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                                                                        <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                                                                        <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
                                                                    </svg>
                                                                }
                                                            </div>

                                                            <Form.Control.Feedback type="invalid">{formik.errors.password}</Form.Control.Feedback>
                                                        </Form.Group>

                                                        <Form.Group className="mb-3" controlId="formBasicPassword">
                                                            <Form.Label>Confirm Password <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                                            <Form.Control
                                                                name='confirmpassword'
                                                                type={confirmpassword ? "text" : "password"}
                                                                onChange={formik.handleChange}
                                                                isValid={formik.touched.confirmpassword && !formik.errors.confirmpassword}
                                                                isInvalid={!!formik.errors.confirmpassword && formik.touched.confirmpassword}
                                                                onBlur={formik.onBlur}
                                                                maxLength="20"
                                                                placeholder='Password'
                                                                required
                                                                value={formik.values.confirmpassword}
                                                            />
                                                            <div className='icon-eye'>
                                                                {confirmpassword ?
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" onClick={() => { viewConfirmPassword() }} className="bi bi-eye" viewBox="0 0 16 16">
                                                                        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                                                                        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                                                                    </svg>
                                                                    :
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" onClick={() => { viewConfirmPassword() }} className="bi bi-eye-slash" viewBox="0 0 16 16">
                                                                        <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                                                                        <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                                                                        <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
                                                                    </svg>
                                                                }
                                                            </div>
                                                            <Form.Control.Feedback type="invalid">{formik.errors.password}</Form.Control.Feedback>
                                                        </Form.Group>
                                                        <div className="group">
                                                            {isloader == true ?
                                                                <div className='loader'>
                                                                    <img src={loader} alt="" />
                                                                </div>
                                                                :
                                                                <Button type="submit" className="btn btn-primary next-btn mt-3 mb-3" >Proceed</Button>
                                                            }
                                                            <Button type="submit" className="btn btn-primary next-btn mt-3 mb-3" onClick={() => { setSwitchbutton("First") }} >Back</Button>
                                                        </div>

                                                    </React.Fragment>
                                                    :
                                                    <React.Fragment>
                                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                                            <Form.Label>Enter OTP <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                                            <Form.Control
                                                                name='otp'
                                                                onChange={formik.handleChange}
                                                                isValid={formik.touched.otp && !formik.errors.otp}
                                                                isInvalid={!!formik.errors.otp}
                                                                maxLength="10"
                                                                placeholder='Enter OTP'
                                                                required
                                                                value={formik.values.otp}
                                                            />
                                                            <Form.Control.Feedback type="invalid">{formik.errors.otp}</Form.Control.Feedback>
                                                        </Form.Group>

                                                        {otpError &&
                                                            <div className='d-flex justify-content-center text-danger'>{otpError}</div>
                                                        }
                                                        <div className="group">
                                                            {isloader == true ?
                                                                <div className='loader'>
                                                                    <img src={loader} alt="" />
                                                                </div>
                                                                :
                                                                <Button type="submit" className="btn btn-primary next-btn mt-3 mb-3" onClick={(e) => __onVerifyOtp(e)}>Verify</Button>

                                                            }
                                                            <div className="forgot-pass">
                                                                <span
                                                                    onClick={() => {
                                                                        resendOTP();
                                                                    }}
                                                                >
                                                                    Resend OTP?{" "}
                                                                </span>
                                                            </div>
                                                        </div>

                                                    </React.Fragment>
                                            }
                                        </Form>


                                        {/* <div className="sign-up-htm">
                                            <div className="group">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="name"
                                                    placeholder="Mobile Number *"
                                                    required=""
                                                />
                                            </div>
                                            <div className="group">
                                                <button type="submit" className="btn btn-primary">Submit</button>
                                            </div>
                                            <div className="hr"></div>
                                            <div className="foot-lnk">
                                                <p>
                                                    Don't have an account? <Link to="">Signup</Link>
                                                </p>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment >
    )
}

export default SignUp;